import * as z from "zod";

export const getReturnsPreFlowStatsInputSchema = z.object({
  startDate: z.string().min(1).optional(),
  endDate: z.string().min(1).optional(),
  /** Exclude setup starts with <60s recorded step time (matches Scorecard/Funnel). Default: true. */
  filterLowIntent: z.boolean().optional(),
});
export type GetReturnsPreFlowStatsInput = z.infer<
  typeof getReturnsPreFlowStatsInputSchema
>;

export const getReturnsPreFlowStatsOutputSchema = z.object({
  installsSelectedReturns: z.number().int().min(0),
  excludedTestOrInternalInstalls: z.number().int().min(0),
  /** Same cleaned cohort as the Scorecard/Funnel `started` count. */
  setupStarts: z.number().int().min(0),
  /** Negative when in-range starts trace to installs completed before the range. */
  installToSetupDelta: z.number().int(),
});
export type GetReturnsPreFlowStatsOutput = z.infer<
  typeof getReturnsPreFlowStatsOutputSchema
>;

export const getReturnsPreFlowStats = {
  name: "getReturnsPreFlowStats" as const,
  input: getReturnsPreFlowStatsInputSchema,
  output: getReturnsPreFlowStatsOutputSchema,
};
